'use strict';

export class StructureSectionsNavigCtrl
{
    $scope;
    jsDataService;
    nodeList = [];
    datasheetNodeList = [];
    navigationList = [];
    datasheetNavigationList = [];
    currentIndex = -1;
    datasheetCurrentIndex = -1;
    byId = {};

    navUrl = 'preview_url';

    constructor($scope, jsDataService){
        'ngInject';
        this.init($scope, jsDataService);
    }

    init($scope, jsDataService){
        this.$scope = $scope;
        let strNodeList = jsDataService.get('structureTreeNodeList', false);
        let strDatasheetNodeList = jsDataService.get('datasheetTreeNodeList', false);

        if(false !== strNodeList){
            this.nodeList = strNodeList;
            this.navigationList = jsDataService.get('structureNavigationList', false);
            let idx = jsDataService.get('structureCurrentIndex', false);
            if(false !== idx){
                this.currentIndex = idx;
            }
            this.indexNodes();
        }
        else{
            this.makeStructureList(jsDataService.get('structureTree', {}));
            jsDataService.set('structureTreeNodeList', this.nodeList);
            jsDataService.set('structureNavigationList', this.navigationList);
            if(this.currentIndex > -1){
                jsDataService.set('structureCurrentIndex', this.currentIndex);
            }
            this.indexNodes();
        }

        if (false !== strDatasheetNodeList) {
            this.datasheetNodeList = strDatasheetNodeList.filter(node => node.structure_key === "42_payments");

            this.datasheetNavigationList = jsDataService.get('datasheetNavigationList', false);
            let idx = jsDataService.get('datasheetStructureCurrentIndex', false);
            if (false !== idx) {
                this.datasheetCurrentIndex = idx;
            }
        } else {
            this.makeStructureList(jsDataService.get('datasheetTree', {}));
            jsDataService.set('datasheetTreeNodeList', this.datasheetNodeList);
            jsDataService.set('datasheetNavigationList', this.datasheetNavigationList);
            if (this.datasheetCurrentIndex > -1) {
                jsDataService.set('datasheetStructureCurrentIndex', this.datasheetCurrentIndex);
            }
        }
        this.buildGroups();
    }

    indexNodes(){
        this.byId = {};
        this.nodeList.forEach(n => { this.byId[n.id] = n; });
    }

    buildGroups(){
        let current = null;
        this.groupOpen = {};
        this.nodeList.forEach(n => {
            if (parseInt(n.level) === 1) {
                current = n.id;
                if (typeof this.groupOpen[current] === 'undefined') this.groupOpen[current] = true;
            }
            n._group = current;
        });
    }

    toggleGroup(node){
        if (parseInt(node.level) === 1) {
            this.groupOpen[node.id] = !this.groupOpen[node.id];
        }
    }

    findPreviewAncestor(node){
        let pid = node.parent_id;
        while (pid){
            const p = this.byId[pid];
            if (p && p.preview_url) return p;
            pid = p ? p.parent_id : null;
        }
        return null;
    }

    gotoNode(ev, node){
        if (!node) return;
		
        if (node.is_page == '0' && node.level == 2) {
            return;
        }
		
        if (node.is_page == '1') {
            this.$scope.goUrl(node.preview_url);
            return;
        }
		
        const target = this.findPreviewAncestor(node) || this.byId[node._group] || null;
        const anchor = node.structure_key || node.key || '';

        if (target && target.preview_url) {
            const dest = target.preview_url + (anchor ? ('#' + anchor) : '');
            if (window.location.pathname === dest.split('#')[0]) {
                this.scrollToId(anchor);
            } else {
                this.$scope.goUrl(dest);
            }
        } else if (anchor) {
            this.scrollToId(anchor);
        }
    }

    scrollToId(id){
        if(!id) return;
        const headerOffset = 86;
        const tryScroll = (n=0)=>{
            const el = document.getElementById(id);
            if(el){
                const y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                try { window.scrollTo({ top: y, behavior: 'smooth' }); }
                catch(e){ window.scrollTo(0, y); }
            } else if(n < 20){
                setTimeout(()=>tryScroll(n+1), 50);
            }
        };
        tryScroll();
    }

    isPreviewException(node){
        return node && node.structure_key == 'a4_work';
    }

    makeStructureList(tree, parentId = null){
        for(let nodeKey in tree){
            let strTree;
            if(tree[nodeKey].haschilds){
                strTree = tree[nodeKey].childs;
                delete tree[nodeKey].childs;
            }
            tree[nodeKey].parent_id = parentId;
            this.nodeList.push(tree[nodeKey]);
            if(this.isAction(tree[nodeKey])){
                this.navigationList.push(tree[nodeKey]);
            }
            if(tree[nodeKey].haschilds){
                this.makeStructureList(strTree, tree[nodeKey].id);
            }
        }
        const index = this.navigationList.findIndex(obj => obj.current === true);
        this.currentIndex = index;
    }

    nodeTitleFormated(node){
        let idt = '';
        let nr = '';
        const tim = 8;
        if(node.numbered == 1 && node.number !== ''){
            nr = node.number + ' ';
        }
        return idt + nr + node.title;
    }

    actionPreview(ev, node){
        if(this.isPreview(node)){
            this.$scope.goUrl(node.preview_url);
        }
    }

    actionEdit(ev, node){
        if(this.isEdit(node)){
            this.$scope.goUrl(node.edit_url);
        }
    }

    isPreviousLink(){
        return (this.currentIndex > 0);
    }

    isNextLink(){
        return (this.currentIndex > -1 && this.currentIndex < (this.navigationList.length-1));
    }

    navPrevious(){
        if(this.isPreviousLink() && typeof(this.navigationList[this.currentIndex - 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex - 1][this.navUrl]) !== 'undefined'){
            this.$scope.goUrl(this.navigationList[this.currentIndex - 1][this.navUrl]);
        }
    }

    navNext(){
        if(this.isNextLink() && typeof(this.navigationList[this.currentIndex + 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex + 1][this.navUrl]) !== 'undefined'){
            this.$scope.goUrl(this.navigationList[this.currentIndex + 1][this.navUrl]);
        }
    }

    getPreviousLink(){
        if(this.isPreviousLink() && typeof(this.navigationList[this.currentIndex - 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex - 1][this.navUrl]) !== 'undefined'){
            return this.navigationList[this.currentIndex - 1][this.navUrl];
        }
        return '';
    }

    getNextLink(){
        if(this.isNextLink() && typeof(this.navigationList[this.currentIndex + 1]) !== 'undefined' && typeof(this.navigationList[this.currentIndex + 1][this.navUrl]) !== 'undefined'){
            return this.navigationList[this.currentIndex + 1][this.navUrl];
        }
        return '';
    }

    isPreview(node){
        return (typeof(node.preview_url) !== 'undefined');
    }

    isEdit(node){
        return (this.isAction(node) && typeof(node.edit_url) !== 'undefined');
    }

    isAction(node){
        return (typeof(node.is_page) !== 'undefined' && (node.is_page === 1 || node.is_page === '1' || node.is_page === 'true' || true === node.is_page));
    }

    isCurrent(node){
        return (typeof(this.navigationList[this.currentIndex]) !== 'undefined' && this.navigationList[this.currentIndex].id === node.id);
    }
}
